<template>
  <section>
    <h3 class="primary--text"><router-link class="no-link-style" style="font-weight:500" :to="{ name: 'Case', params: { case_id: eventDateObj.caseId} }"> {{ eventDateObj.title }}</router-link>
    changed state from <i style="font-weight:400;">{{ eventDateObj.params.from }}</i> to
              <i style="font-weight:400; color:green">{{ eventDateObj.params.to }}</i></h3>
  </section>

</template>

<script>

export default {
  name: "StateChange",
  data: () => ({
  }),
  props: ["eventDateObj"],
  methods: {
    setStateName: function(param) {
      param.name = 'State'
      return param
    }
  }
}
</script>
